<template>
  <div class="demandes-sites">
    <div class="card"><div class="card-body">
      <div class="tc-entete ds-entete">
        <div class="tc-titre">
          <h3 class="c-title">Demandes des sites</h3>
          <button type="button" class="tc-actualiser" title="Actualiser" aria-label="Actualiser" :disabled="chargement" @click="charger()"><i class="fa fa-sync-alt" :class="{ 'fa-spin': chargement }" aria-hidden="true"></i></button>
        </div>
        <div class="ds-filtres" role="group" aria-label="Afficher">
          <button v-for="filtre in filtres" :key="filtre.id" type="button" :class="{ actif: statut === filtre.id }" :aria-pressed="statut === filtre.id ? 'true' : 'false'" @click="choisirStatut(filtre.id)">
            {{ filtre.libelle }}<span v-if="filtre.id === 'en_attente' && enAttente" class="ds-compteur">{{ enAttente }}</span>
          </button>
        </div>
      </div>
      <p class="ds-aide"><i class="fa fa-info-circle" aria-hidden="true"></i><span>Vérifiez le patient, choisissez le médecin et l’heure, puis confirmez le rendez-vous au patient.
        <small>Une demande ne réserve pas de créneau. Aucun SMS ni courriel n’est envoyé automatiquement.</small></span></p>
      <p v-if="info" role="status" class="tc-info">{{ info }} <button type="button" class="tc-lien" @click="info = ''">Fermer</button></p>
      <p v-if="erreur" role="alert" class="tc-erreur">{{ erreur }} <button type="button" class="tc-lien" :disabled="chargement" @click="charger()">Réessayer</button></p>
      <div v-if="chargement" class="pdtb-2 algn-center"><div class="spinner-border text-secondary" role="status"><span class="sr-only">Chargement…</span></div></div>
      <div v-else-if="!erreur && !demandes.length" class="ds-vide" role="status">
        <div class="ds-vide-icone"><i class="far fa-calendar-check" aria-hidden="true"></i></div>
        <h4>Aucune demande {{ libelleStatut }}</h4>
        <p>{{ statut === 'en_attente' ? 'Les nouvelles demandes reçues sur le site apparaîtront ici.' : 'Les demandes traitées apparaîtront dans cet onglet.' }}</p>
      </div>
      <div v-else-if="demandes.length" class="tc-table-scroll">
        <table class="table tc-table ds-table">
          <thead><tr><th scope="col">Reçue le</th><th scope="col">Patient</th><th scope="col">Contact</th><th scope="col">Spécialité souhaitée</th><th scope="col">Date souhaitée</th><th scope="col" class="tc-actions">{{ statut === 'en_attente' ? 'Action' : 'Suite' }}</th></tr></thead>
          <tbody>
            <tr v-for="demande in demandes" :key="demande.id">
              <td>{{ dateHeure(demande.created_at) }}</td>
              <td><strong>{{ demande.contact.name }}</strong><small class="d-block text-grey">Réf. {{ referenceCourte(demande.reference) }}</small></td>
              <td><a :href="'tel:' + telephoneLien(demande.contact.phone)">{{ demande.contact.phone }}</a>
                <a v-if="demande.contact.email" class="d-block" :href="'mailto:' + demande.contact.email">{{ demande.contact.email }}</a></td>
              <td>{{ demande.contact.specialty }}</td>
              <td>{{ date(demande.contact.preferred_date) }}<small class="d-block text-grey">{{ demande.contact.preferred_time || 'Heure à convenir' }}</small></td>
              <td class="tc-actions">
                <button v-if="demande.status === 'en_attente'" type="button" class="btn btn-primary btn-sm btn-radius" @click="ouvrir(demande)">Traiter</button>
                <span v-else-if="demande.status === 'acceptee'" class="ds-pastille ds-pastille-ok">Rendez-vous créé<span v-if="demande.rendez_vous_id"> n° {{ demande.rendez_vous_id }}</span></span>
                <span v-else class="ds-pastille ds-pastille-refus">Refusée</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="dernierePage > 1" class="ds-pages">
        <button type="button" class="btn btn-secondary-light-o btn-sm" :disabled="page <= 1 || chargement" @click="page--; charger()">Précédent</button>
        <span>Page {{ page }} / {{ dernierePage }}</span>
        <button type="button" class="btn btn-secondary-light-o btn-sm" :disabled="page >= dernierePage || chargement" @click="page++; charger()">Suivant</button>
      </div>
    </div></div>

    <div v-if="dossier" class="ds-fenetre" role="dialog" aria-modal="true" aria-labelledby="ds-titre">
      <form class="ds-fenetre-contenu" novalidate @submit.prevent="accepter">
        <div class="ds-fenetre-entete">
          <div>
            <h4 id="ds-titre" class="mb-0">Demande de {{ dossier.demande.contact.name }}</h4>
            <span class="text-grey">{{ dossier.demande.contact.specialty }} · souhaité le {{ date(dossier.demande.contact.preferred_date) }} {{ dossier.demande.contact.preferred_time || '(heure à convenir)' }}
              · <a :href="'tel:' + telephoneLien(dossier.demande.contact.phone)">{{ dossier.demande.contact.phone }}</a></span>
          </div>
          <button type="button" class="btn btn-link ds-fermer" aria-label="Fermer" @click="fermer">×</button>
        </div>
        <div class="ds-corps">
          <div v-if="dossier.chargement" class="text-grey">Chargement…</div>
          <template v-else>
            <h5 class="ds-etape">1. Patient</h5>
            <div v-if="dossier.patient" class="ds-choisi">
              <strong>{{ dossier.patient.nom }} {{ dossier.patient.prenoms }}</strong> · dossier {{ dossier.patient.code || '—' }}
              <button type="button" class="tc-lien" @click="dossier.patient = null">Changer</button>
            </div>
            <template v-else>
              <div class="ds-recherche">
                <input id="ds-recherche" v-model.trim="dossier.recherche" type="search" class="input-secondary-light" maxlength="100"
                  aria-label="Nom ou numéro de dossier" placeholder="Nom ou numéro de dossier" @keydown.enter.prevent="chercherPatients">
                <button type="button" class="btn btn-primary-light btn-radius" :disabled="dossier.recherche.length < 3 || dossier.recherche_en_cours" @click="chercherPatients">Rechercher</button>
                <button type="button" class="btn btn-secondary-light-o btn-radius" @click="nouveauDossier">+ Nouveau dossier</button>
              </div>
              <p v-if="dossier.recherche_en_cours" class="text-grey">Recherche…</p>
              <ul v-else-if="dossier.patients.length" class="ds-patients">
                <li v-for="patient in dossier.patients" :key="patient.id">
                  <button type="button" @click="dossier.patient = patient"><strong>{{ patient.nom }} {{ patient.prenoms }}</strong><span>dossier {{ patient.code || '—' }}</span></button>
                </li>
              </ul>
              <p v-else-if="dossier.recherche_faite" class="text-grey">Aucun dossier trouvé : vérifiez l’orthographe ou créez un nouveau dossier.</p>
            </template>

            <h5 class="ds-etape">2. Rendez-vous</h5>
            <div class="form-row">
              <div class="form-group col-md-4"><label for="ds-specialite">Spécialité *</label>
                <select id="ds-specialite" v-model="dossier.type_consultation_id" class="input-secondary-light" @change="dossier.medecin_id = ''">
                  <option value="">Choisir</option>
                  <option v-for="type in referentiel.types_consultations || []" :key="type.id" :value="type.id">{{ type.nom }}</option>
                </select></div>
              <div class="form-group col-md-4"><label for="ds-medecin">Médecin habilité *</label>
                <select id="ds-medecin" v-model="dossier.medecin_id" class="input-secondary-light" :disabled="!dossier.type_consultation_id">
                  <option value="">{{ dossier.type_consultation_id && !medecinsHabilites.length ? 'Aucun médecin habilité' : 'Choisir' }}</option>
                  <option v-for="medecin in medecinsHabilites" :key="medecin.id" :value="medecin.id">{{ medecin.nom }}</option>
                </select></div>
              <div class="form-group col-md-4"><label for="ds-date">Date et heure * <small class="text-grey">({{ referentiel.timezone || 'heure de l’établissement' }})</small></label>
                <input id="ds-date" v-model="dossier.date_heure" type="datetime-local" class="input-secondary-light"></div>
            </div>
            <p v-if="dossier.erreur" class="text-danger" role="alert">{{ dossier.erreur }}</p>
          </template>
        </div>
        <div class="ds-pied">
          <template v-if="dossier.confirmer_refus">
            <span class="ds-refus-question">Refuser cette demande ? Prévenez ensuite le patient.</span>
            <button type="button" class="btn btn-secondary-light-o btn-radius" @click="dossier.confirmer_refus = false">Non</button>
            <button type="button" class="btn btn-danger btn-radius" :disabled="dossier.envoi" @click="refuser">Oui, refuser</button>
          </template>
          <template v-else>
            <button type="button" class="btn btn-outline-danger btn-radius" :disabled="dossier.envoi" @click="dossier.confirmer_refus = true">Refuser la demande</button>
            <button type="button" class="btn btn-secondary-light-o btn-radius" @click="fermer">Fermer</button>
            <button type="submit" class="btn btn-primary btn-radius" :disabled="dossier.envoi || dossier.chargement">{{ dossier.envoi ? 'Enregistrement…' : 'Créer le rendez-vous' }}</button>
          </template>
        </div>
      </form>
    </div>

    <ModalCreerPatient v-if="creationPatient" :key="'creation-' + cleCreation" type_enreg="rendez_vous" :identite_initiale="identiteNouveauPatient" @passNewPatient="patientCree" />
  </div>
</template>

<script>
import $ from 'jquery'
import api_rdv from '@/api/clinique/_rendez_vous'
import ModalCreerPatient from '@/components/creer-patient-modal'

const FILTRES = [
  { id: 'en_attente', libelle: 'En attente' },
  { id: 'acceptee', libelle: 'Acceptées' },
  { id: 'refusee', libelle: 'Refusées' },
]

function normaliser(texte) {
  return String(texte || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()
}

function messageErreur(erreur, defaut) {
  const donnees = erreur && erreur.response ? erreur.response.data : null
  return (donnees && donnees.message) || (erreur && erreur.message) || defaut
}

// Demandes de rendez-vous des sites des clients Clinicaa (04/10/2026), déplacées de la Clinique vers
// Accueil / Caisse › Rendez-vous ; même serveur et mêmes droits (capacité rendez-vous de l'Accueil et de la Caisse).
export default {
  name: 'demandes-sites',
  components: { ModalCreerPatient },
  data() {
    return {
      filtres: FILTRES, statut: 'en_attente', page: 1, dernierePage: 1, demandes: [], enAttente: 0,
      chargement: true, erreur: '', info: '', acces: null, referentiel: {}, dossier: null,
      creationPatient: false, cleCreation: 0, identiteNouveauPatient: null,
    }
  },
  computed: {
    libelleStatut() {
      return { en_attente: 'en attente', acceptee: 'acceptée', refusee: 'refusée' }[this.statut]
    },
    // Comme « Prendre un rendez-vous » : médecins habilités pour la spécialité ; sans habilitation connue, tout l'annuaire.
    medecinsHabilites() {
      if (!this.dossier || !this.dossier.type_consultation_id) return []
      const carte = this.referentiel.medecins_par_type || {}
      const ids = (carte[String(this.dossier.type_consultation_id)] || []).map(Number)
      const medecins = (this.acces && Array.isArray(this.acces.medecins)) ? this.acces.medecins : []
      return ids.length ? medecins.filter(medecin => ids.indexOf(Number(medecin.id)) >= 0) : medecins
    },
  },
  mounted() {
    this.charger()
  },
  methods: {
    date(valeur) {
      if (!valeur) return '—'
      const morceaux = String(valeur).slice(0, 10).split('-')
      return morceaux.length === 3 ? morceaux[2] + '/' + morceaux[1] + '/' + morceaux[0] : valeur
    },
    dateHeure(valeur) {
      if (!valeur) return '—'
      const texte = String(valeur).replace('T', ' ')
      return this.date(texte) + (texte.length >= 16 ? ' ' + texte.slice(11, 16) : '')
    },
    referenceCourte(reference) {
      return String(reference || '').slice(0, 8).toUpperCase()
    },
    telephoneLien(telephone) {
      return String(telephone || '').replace(/[^0-9+]/g, '')
    },
    async jeton() {
      this.acces = await api_rdv.access()
      return this.acces.access_token
    },
    async charger() {
      this.chargement = true
      this.erreur = ''
      try {
        const jeton = await this.jeton()
        const reponse = await api_rdv.demandesSites({ status: this.statut, page: this.page }, jeton)
        this.demandes = Array.isArray(reponse.data) ? reponse.data : []
        this.dernierePage = reponse.last_page || 1
        if (this.statut === 'en_attente') {
          this.enAttente = reponse.total || this.demandes.length
        } else {
          const attente = await api_rdv.demandesSites({ status: 'en_attente', page: 1 }, jeton)
          this.enAttente = attente.total || 0
        }
        this.$emit('compteur', this.enAttente)
      } catch (erreur) {
        this.demandes = []
        this.erreur = messageErreur(erreur, 'Les demandes des sites n’ont pas pu être chargées.')
      } finally {
        this.chargement = false
      }
    },
    choisirStatut(statut) {
      this.statut = statut
      this.page = 1
      this.charger()
    },
    // Spécialité saisie librement sur le site : proposée si elle correspond à une spécialité de l'établissement.
    specialiteCorrespondante(texte) {
      const cherche = normaliser(texte)
      if (!cherche) return ''
      const types = this.referentiel.types_consultations || []
      const exact = types.find(type => normaliser(type.nom) === cherche)
      const proche = exact || types.find(type => normaliser(type.nom).indexOf(cherche) >= 0 || cherche.indexOf(normaliser(type.nom)) >= 0)
      return proche ? proche.id : ''
    },
    async ouvrir(demande) {
      this.info = ''
      const contact = demande.contact || {}
      this.dossier = {
        demande, chargement: true, recherche: String(contact.name || ''), recherche_en_cours: false, recherche_faite: false, patients: [],
        patient: null, type_consultation_id: '', medecin_id: '',
        date_heure: contact.preferred_date ? contact.preferred_date + 'T' + (contact.preferred_time || '08:00') : '',
        erreur: '', envoi: false, confirmer_refus: false,
      }
      try {
        const jeton = await this.jeton()
        const reponse = await api_rdv.referentiel(jeton)
        this.referentiel = (reponse && reponse.data) || {}
        this.dossier.type_consultation_id = this.specialiteCorrespondante(contact.specialty)
      } catch (erreur) {
        this.dossier.erreur = messageErreur(erreur, 'Le référentiel des rendez-vous n’a pas pu être chargé.')
      } finally {
        this.dossier.chargement = false
      }
      if (this.dossier.recherche.length >= 3) this.chercherPatients()
    },
    fermer() {
      this.dossier = null
    },
    async chercherPatients() {
      const d = this.dossier
      if (!d || d.recherche.length < 3) return
      d.recherche_en_cours = true
      try {
        const reponse = await api_rdv.patientsDemandeSite(d.recherche, await this.jeton())
        d.patients = Array.isArray(reponse.data) ? reponse.data : []
      } catch (erreur) {
        d.patients = []
        d.erreur = messageErreur(erreur, 'La recherche de dossier a échoué.')
      } finally {
        d.recherche_en_cours = false
        d.recherche_faite = true
      }
    },
    // Nouveau dossier : fenêtre habituelle « Ajouter un nouveau patient », pré-remplie avec le nom et le téléphone.
    nouveauDossier() {
      const contact = this.dossier.demande.contact || {}
      const mots = String(contact.name || '').trim().split(/\s+/).filter(Boolean)
      const majuscules = mots.filter(mot => mot.length > 1 && mot === mot.toUpperCase())
      const nom = majuscules.length ? majuscules.join(' ') : (mots[0] || '')
      const prenoms = mots.filter(mot => majuscules.length ? majuscules.indexOf(mot) < 0 : mot !== mots[0]).join(' ')
      this.identiteNouveauPatient = { nom, prenoms, telephone: contact.phone || '' }
      // Fenêtre remontée à chaque demande (pré-remplissage au montage) ; elle se ferme seule après l'enregistrement.
      this.cleCreation++
      this.creationPatient = true
      this.$nextTick(() => $('#add-patient').modal('show'))
    },
    patientCree(patient) {
      if (this.dossier && patient && patient.patient_id) {
        this.dossier.patient = { id: patient.patient_id, nom: patient.patient_nom, prenoms: '', code: patient.num_dossier }
      }
    },
    async accepter() {
      const d = this.dossier
      if (!d.patient) { d.erreur = 'Choisissez ou créez le dossier du patient.'; return }
      if (!d.type_consultation_id || !d.medecin_id || !d.date_heure) { d.erreur = 'Choisissez la spécialité, le médecin et la date.'; return }
      await this.traiter({ action: 'accepter', patient_id: d.patient.id, medecin_id: Number(d.medecin_id),
        type_consultation_id: Number(d.type_consultation_id), date_heure: String(d.date_heure).slice(0, 16) })
    },
    async refuser() {
      await this.traiter({ action: 'refuser' })
    },
    async traiter(donnees) {
      const d = this.dossier
      d.envoi = true
      d.erreur = ''
      try {
        const reponse = await api_rdv.traiterDemandeSite(d.demande.id, donnees, await this.jeton())
        const conflit = reponse.conflits && reponse.conflits.length ? ' Attention : conflit de planning signalé, vérifiez l’agenda.' : ''
        this.info = (reponse.message || 'Demande traitée.') + conflit
        this.dossier = null
        await this.charger()
      } catch (erreur) {
        d.erreur = messageErreur(erreur, 'Le traitement de la demande a échoué.')
        d.envoi = false
        d.confirmer_refus = false
      }
    },
  },
}
</script>

<style scoped>
.demandes-sites { color: #172033 }
.demandes-sites .card { border: 1px solid #e0e7f3; border-radius: 20px; box-shadow: none }
.demandes-sites .card-body { padding: 24px }
.ds-entete { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px; margin-bottom: 18px }
.tc-titre { display: flex; align-items: center; gap: 12px }
.tc-titre .c-title { color: #172033; font-size: 22px; margin: 0; font-weight: 700 }
.tc-actualiser { display: inline-flex; align-items: center; justify-content: center; width: 38px; height: 38px; border: 1px solid #c7d5f1; border-radius: 12px; color: #285bd4; background: #fff }
.tc-actualiser:hover { background: #eaf0ff }
.tc-actualiser:disabled { opacity: .55; cursor: wait }
.demandes-sites button:focus-visible, .demandes-sites a:focus-visible { outline: 3px solid #8caaf5; outline-offset: 2px }
.demandes-sites .btn { border-radius: 999px; min-height: 36px; padding: 7px 16px; font-weight: 600 }
.demandes-sites .text-grey { color: var(--ui-text, #526074) !important }
.demandes-sites input, .demandes-sites select { border: 1px solid #bdcbe0; border-radius: 10px; color: #172033; background: #fff; min-height: 42px }
.tc-info, .tc-erreur { padding: 12px 16px; border-radius: 12px; background: #edf7f1; color: #195136 }
.tc-erreur { background: #fff0f0; color: #9b2626 }
.tc-lien { border: 0; background: transparent; color: #214db0; text-decoration: underline; padding: 2px 6px }
.ds-filtres { display: flex; gap: 6px; flex-wrap: wrap }
.ds-filtres button { border: 1px solid #d7e3fa; background: #fff; color: #172033; border-radius: 999px; padding: 8px 16px; font-weight: 600; font-size: 14px; min-height: 38px }
.ds-filtres button.actif { background: #285bd4; border-color: #285bd4; color: #fff }
.ds-compteur { display: inline-block; min-width: 20px; margin-left: 6px; padding: 0 6px; border-radius: 999px; background: #e5484d; color: #fff; font-size: 12px; text-align: center }
.ds-aide { display: flex; align-items: flex-start; gap: 10px; background: #f3f6fc; border-radius: 12px; padding: 14px 16px; font-size: 14px; line-height: 1.6; margin: 0 0 18px; color: var(--ui-text, #273449) }
.ds-aide i { margin-top: 4px; color: #285bd4 }
.ds-aide small { display: block; margin-top: 3px; color: var(--ui-text, #526074) }
.ds-vide { text-align: center; padding: 38px 16px 32px }
.ds-vide-icone { display: inline-flex; align-items: center; justify-content: center; height: 56px; width: 56px; border-radius: 18px; background: #eaf0ff; color: #285bd4; font-size: 24px; margin-bottom: 16px }
.ds-vide h4 { font-size: 19px; color: #172033; margin: 0 0 8px; font-weight: 600 }
.ds-vide p { font-size: 14px; color: var(--ui-text, #374151); margin: 0 }
.tc-table-scroll { overflow-x: auto }
.ds-table { color: #172033; margin: 0; min-width: 750px }
.ds-table th { border: 0; background: #f1f5fb; color: var(--ui-text, #273449); padding: 12px; font-size: 13px; white-space: nowrap }
.ds-table td { vertical-align: middle; padding: 14px 12px; border-color: #e4eaf3 }
.ds-table td a { color: #214db0 }
.ds-table tbody tr:hover { background: #f8faff }
.ds-table small { margin-top: 4px }
.ds-pastille { display: inline-block; padding: 3px 10px; border-radius: 999px; font-size: 13px; font-weight: 600 }
.ds-pastille-ok { background: #e7f6ee; color: #1e8e5a }
.ds-pastille-refus { background: #fdecec; color: #b42318 }
.ds-pages { display: flex; align-items: center; gap: 12px; justify-content: flex-end; margin-top: 12px }
.ds-fenetre { position: fixed; z-index: 1040; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(30, 40, 64, .45); backdrop-filter: blur(5px); padding: 16px }
.ds-fenetre-contenu { display: flex; flex-direction: column; width: 100%; max-width: 900px; max-height: 92vh; background: #fff; border-radius: 16px; overflow: hidden }
.ds-fenetre-entete { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; padding: 18px 24px; border-bottom: 1px solid #edf0f6 }
.ds-fenetre-entete h4 { font-size: 21px; line-height: 1.3 }
.ds-fermer { font-size: 24px; line-height: 1 }
.ds-corps { padding: 20px 24px; overflow-y: auto; background: #f7f9fe }
.ds-corps .form-group label { display: block }
.ds-etape { font-size: 16px; font-weight: 700; color: var(--ui-text, #304269); margin: 6px 0 10px }
.ds-recherche { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 8px }
.ds-recherche input { flex: 1; min-width: 220px }
.ds-patients { list-style: none; margin: 0 0 12px; padding: 6px; border: 1px solid #d7e3fa; border-radius: 12px; background: #fff; max-height: 220px; overflow-y: auto }
.ds-patients button { display: flex; justify-content: space-between; width: 100%; text-align: left; border: 0; background: transparent; padding: 8px 10px; border-radius: 8px }
.ds-patients button:hover { background: #f2f8ff }
.ds-patients span { color: var(--ui-text-secondary, #65728b); font-size: 13px }
.ds-choisi { padding: 10px 12px; margin-bottom: 12px; border-radius: 10px; background: #e7f6ee; color: #1e5f3e }
.ds-pied { display: flex; justify-content: flex-end; align-items: center; gap: 8px; padding: 14px 24px; border-top: 1px solid #edf0f6; flex-wrap: wrap }
.ds-refus-question { margin-right: auto; color: #b42318; font-weight: 600 }
@media (max-width: 700px) { .ds-corps, .demandes-sites .card-body { padding: 16px } .ds-entete { align-items: flex-start } .ds-filtres { width: 100% } .ds-pages { justify-content: center; flex-wrap: wrap } }
</style>
